import { render, staticRenderFns } from "./medicTruckData.vue?vue&type=template&id=7f53072c"
import script from "./medicTruckData.vue?vue&type=script&lang=js"
export * from "./medicTruckData.vue?vue&type=script&lang=js"
import style0 from "./medicTruckData.vue?vue&type=style&index=0&id=7f53072c&prod&lang=css"
import style1 from "./medicTruckData.vue?vue&type=style&index=1&id=7f53072c&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports